<template>
	<div class="opts_wrap" v-loading="loading">
		<div class="opts_line">
			<p>已勾选订单数：{{total}}</p>
			<p>发货成功数：{{success_num}}</p>
			<p>发货失败数：{{fail_num}}</p>
			<el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
		</div>
		
		<div class="btn_wrap">
			<p class="btn" :class="total==0||is_posting?'disabled':''" @click="batDeliver()">批量发货</p>
			<p class="btn" @click="cancel()">取消</p>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
export default {
	name: "orderBatDeliver",
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		show: {
			type: Boolean,
			default: false
		},
		ids: {
			type: Array,
			default: []
		},
	},
	data() {
		return {
			loading: false,
			arr_ids:[],
			percentage:0,
			list:[],
			total: 0,
			success_num: 0,
			fail_num: 0,
			is_posting: false
		};
	},
	
	created(){
		this.init()
	},
	mounted() {
	},
	
	computed:{
		...mapState({
		}),
	},
	watch:{
		show(val) {
			if(val){
				this.arr_ids = this.ids
				this.percentage = 0
				this.init()
			}
		}
	},
	
	methods: {
		...mapActions({
			getBatDeliverOrderData:"ucenter/getBatDeliverOrderData",
			opSupplierOrderDeliver:"ucenter/opSupplierOrderDeliver",
		}),
		init(){
			this.arr_ids = this.ids
			console.log(this.arr_ids)
			this.is_posting = false
			this.total = 0
			this.success_num = 0
			this.fail_num = 0
			if(this.ids.length == 0){
				this.$emit('close', {})
				return
			}
			this.getInfo()
		},
		getInfo(){
			this.loading = true
			this.getBatDeliverOrderData({data:{ids:this.arr_ids},success:(res)=>{
				if(res.code == 200){
					this.list = res.data
					this.total = this.list.length
				}else{
					this.$message({message: res.msg,type: 'error'})
				}
				this.loading = false
			}})
		},
		
		batDeliver(){
			if(this.is_posting) return
			this.success_num = 0
			this.fail_num = 0
			this.is_posting = true
			this.postDeliver(0)
		},
		
		postDeliver(idx){
			//一条条记录请求发货
			let order = this.list[idx]
			let param = {
				order_id:order.order_id,
				logistics_company_id:order.supplier_order_print.logistics_company.id,
				logistics_code:order.supplier_order_print.track_no,
			}
			
			this.opSupplierOrderDeliver({data:param,success:(res)=>{
				if(res.code == 200){
					this.success_num ++
				}else{
					this.fail_num ++
				}
				var total = this.total
				this.percentage = Number(((idx+1)/total*100).toFixed(2))
				if(total-1 > idx){
					this.postDeliver(idx + 1)	
				}else{
					// this.is_posting = false
					this.$message({message: '操作完成',type: 'success'})
					this.$emit('success', {})
				}
			}})
		},
		
		cancel(){
			this.$emit('close', {})
		},
		
	},

}
</script>

<style scoped>
	.opts_wrap{padding-top: 14px;}
	.opts_wrap .opts_line p{margin-bottom: 15px;}
	.opts_wrap .btn_wrap{margin: 40px auto 0 auto;display: flex;align-items: center;justify-content: center;}
	.opts_wrap .btn_wrap .btn{width: 80px;height: 34px;border-radius: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;box-sizing: border-box;font-size: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;margin-right: 14px;}
	.opts_wrap .btn_wrap .btn.disabled{background-color: #C0C4CC;color: #333;}
	.opts_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #333;border: 1px solid #ddd;margin-right: 14px;}
	.ml8{margin-left: 8px;}
	.opts_wrap .btn_wrap .btn:nth-child(3){background: #fff;color: #333;border: 1px solid #ddd;}
	.w80{width: 80px;}
	.w100{width: 100%;}
	.s_line{padding:0 12px;height: 34px;line-height: 34px;border:1px solid #DCDFE6;border-radius:4px;width: 100%;}
	.s_line .label{color:#C0C4CC;font-size:14px;width: 68px;display:inline-block;}
	.s_line .info{display:inline-block;}
	
	.el-input{height: 34px;line-height: 34px;}
	/deep/.el-input__prefix{height:34px;line-height:34px;margin-left:15px;left: 0 !important;}
	/deep/.el-select .el-input__inner{padding-left:80px;height:34px;line-height:34px;}
	/deep/.el-input--prefix .el-input__inner, .el-cascader .el-input .el-input__inner{padding-left:80px;height: 34px !important;}
	/deep/.el-progress-bar__innerText{color: #333 !important;}
</style>
